import type { IAndroidPowerStatus } from '@/helpers/parseAndroidPowerStatus'

/** Subset of the (Chromium-only) Battery Status API `BatteryManager` used for telemetry. */
export interface IWebBatteryManagerLike {
  charging?: unknown
  level?: unknown
}

/**
 * Maps a Battery Status API reading to the heartbeat power fields.
 *
 * The web cannot tell `ac` from `usb`/`wireless`, so any charging state reports `ac` (approximate).
 * Desktops without a battery report `level: 1` + `charging: true`; that is indistinguishable from a full
 * battery on mains, so it is reported as a present, full, mains-powered battery.
 */
export function parseWebBatteryStatus(raw: unknown): IAndroidPowerStatus | null {
  if (raw == null || typeof raw !== 'object') {
    return null
  }
  const { charging, level } = raw as IWebBatteryManagerLike
  if (typeof charging !== 'boolean' || typeof level !== 'number' || !Number.isFinite(level)) {
    return null
  }
  return {
    batteryPresent: true,
    batteryPercent: Math.min(100, Math.max(0, Math.round(level * 100))),
    powerSource: charging ? 'ac' : 'battery',
    batteryCharging: charging
  }
}
